import supportClientFactory from './apigClient'
import AWSClockSkewHandler from "../AWSClockSkewHandler"
import store from "@/store"

class SupportApi {
  constructor() {
    this.inited = false
    this.client = null
  }

  init() {
    if(!this.inited) {
      this.inited = true
      console.log(process.env.VUE_APP_SUPPORT_URL)
      this.client = supportClientFactory.newClient(store.state.credentials, process.env.VUE_APP_SUPPORT_URL)
    }
  }

  async callSupport(action, params = {}) {
    this.init()

    let error
    let result = await AWSClockSkewHandler.handleClockSkew(() => {
      return this.client.supportPost({
        deviceUUID: store.state.deviceUUID
      }, {
        action,
        ...params
      })
    }).catch(err => {
      error = err
    })

    if(error) throw error
    return result
  }

  async listTickets() {
    return this.callSupport('list_tickets')
  }

  async getTicket(accountId, createdAt) {
    return this.callSupport('get_ticket', { accountId, createdAt })
  }

  async getUploadUrl(createdAt, filename, contentType, size) {
    const params = { filename, contentType, size }
    if (createdAt) params.createdAt = createdAt
    return this.callSupport('get_upload_url', params)
  }

  async uploadToPresignedUrl(url, file) {
    const response = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type }
    })
    if (!response.ok) throw new Error(`Upload failed: ${response.status}`)
  }

  async newTicket(message, attachments) {
    const params = { message }
    if (attachments && attachments.length > 0) params.attachments = attachments
    return this.callSupport('new_ticket', params)
  }

  async sendMessage(accountId, createdAt, message, attachments) {
    const params = { accountId, createdAt, message }
    if (attachments && attachments.length > 0) params.attachments = attachments
    return this.callSupport('send_message', params)
  }

  async requestHuman(accountId, createdAt) {
    return this.callSupport('request_human', { accountId, createdAt })
  }

  async requestAI(accountId, createdAt) {
    return this.callSupport('request_ai', { accountId, createdAt })
  }

  async closeTicket(accountId, createdAt, closeMessage) {
    return this.callSupport('close_ticket', { accountId, createdAt, closeMessage })
  }

  async reopenTicket(accountId, createdAt) {
    return this.callSupport('reopen_ticket', { accountId, createdAt })
  }
}

export default (new SupportApi())
